import clsx from "clsx";

interface Props extends React.HTMLAttributes<HTMLDivElement> {
    children?: React.ReactNode;
    className?: string;
    }
export default function Container({children,className,...rest}:Props) {
  return (
    <div {...rest} className={clsx("mt-6 flow-root",className)}>
      <div className="inline-block min-w-full align-middle">
        <div className="rounded-lg bg-gray-50 p-2 md:pt-0">
            {children}
        </div>
      </div>
    </div>
  );
}
